<!--Under Maintenance Starts-->
<section id="maintenance" class="full-height-vh">
  <div class="container-fluid">
    <div class="row full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="row">
          <div class="col-sm-12 text-center">
            <img src="../../../assets/img/gallery/maintenance.png" alt="" class="img-fluid maintenance-img mt-2"
              height="300" width="400">
            <h1 class="text-white mt-4">This page is under maintenance!</h1>
            <div class="w-75 mx-auto maintenance-text mt-3">
              <p class="text-white">We're sorry for the inconvenience. Please come back later.
              </p>
            </div>
            <button (click)="Reconnect()" class="btn btn-primary btn-lg mt-4"><a  class="text-decoration-none text-white">Back
                To Home</a></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Under Maintenance Starts-->
